import axios from "axios";

import { GET_DASHBOARD } from "./types";
import { apiInstanceFetch } from "../../util/api";
export const getDashboard = () => (dispatch) => {
  const token = localStorage.getItem("token");
  axios
    .get("/dashboard" , {
      Authorization : {
        Headers : {
          token : token
        }
      }
    })
    .then((res) => {
      
      // console.log(res.data.data);
      dispatch({ type: GET_DASHBOARD, payload: res.data });
    })
    .catch((error) => console.log(error));
};
